/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PipelineFilterSchemaAddedWithin = typeof PipelineFilterSchemaAddedWithin[keyof typeof PipelineFilterSchemaAddedWithin] | null;


export const PipelineFilterSchemaAddedWithin = {
  '24h': '24h',
  '7d': '7d',
  '14d': '14d',
  '30d': '30d',
  '60d': '60d',
  '90d': '90d',
  '180d': '180d',
  '365d': '365d',
} as const;
